import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import useAxios from '../../../../Hooks/use-axios';
import { winnreAuth } from '../../../../utils/axios';
import { dealAction } from '../../../../store/deal-slice'; // Ensure you have the actions to save deals
import store from '../../../../store';
const useData = (dealId, isRewards) => {
    const [deal, setDeal] = useState('');
    const [bundleDeals, setBundleDeals] = useState([]);
    const[otherBundleDeals , setOtherBundleDeals]=useState([]);
    const [bundleDealDetails, setBundleDealDetails] = useState([]);
    const { isLoading: loadingBundleDeals, sendRequest: fetchBundleDeals } =
        useAxios();
    const [similarOffers, setSimilarOffers] = useState([]);
    const [topOffers, setTopOffers] = useState([]);
    const [sameBrandOffers, setSameBrandOffers] = useState([]);
    const [faultyDeal, setFaultyDeal] = useState(false);
    const { isLoading: loadingDeal, sendRequest: fetchDealDetails } =
        useAxios();
    const { isLoading: loadingSimilarDeals, sendRequest: fetchSimilarDeals } =
        useAxios();
    const [cartAmount, setCartAmount] = useState(0);

    const isRewardRefreshing = useSelector(
        (state) => state.deals.isRefreshRewards
    );

    const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
    const totalRewardspoint = useSelector((state) => state.auth.rewardPoints);
    const dispatch = useDispatch();
    const state = store.getState(); // Access the current store state

    const getDealDetails = () => {
        setFaultyDeal(false);

        fetchDealDetails(
            {
                isEncryptedResponse: isAuthenticated ? true : false,
                url: isAuthenticated
                    ? `/winnre/user/deals/${dealId}`
                    : `/cms_service/deals/${dealId}`,
                method: 'get'
            },
            (data) => {
                // console.log(
                //     'desc',
                //     data?.description,
                //     'specs',
                //     data?.productSpecs
                // );
                console.log('deal details', data);
                if (data?.status == 'FAILED') {
                    setFaultyDeal(true);
                    return;
                }
                setDeal(data);
                if (isAuthenticated && data.category?.id !== 4) {
                    if (data?.category?.id == '8') {
                        getBundleDealsWithSameTag(data?.tags[0]?.id, data?.id);
                    }
                    getSimilarOffersByCategory(
                        data.id,
                        data?.category?.id,
                        data?.rewardCategory?.id, 
                        data?.tags[0]?.id
                    );
                    getSameBrandOffers(data.id, data.vendor.id);
                }
            }
        );
    };

    // const getBundleDealsWithSameTag = (id) => {
    //     const url = `/winnre/user/deals/filter-v2?&status=PUBLISHED&isAscending=false&sortBy=priority&categoryList=8&pageSize=10&tagList=${id}${
    //         isRewards ? '&rewardsPage=true' : ''
    //     }`;
    //     let cachedBundleDeals = state.deals.bundleDealCache[url] || null;
    //     if (cachedBundleDeals) {
    //         // Use cached deals if available
    //         console.log('Using cached bundle deals:', cachedBundleDeals);
    //         setBundleDeals(cachedBundleDeals);
    //         const bundleIds = cachedBundleDeals.map((offer) => offer.id);
    //         let apiCall = Promise.all(
    //             bundleIds?.map((id) =>
    //                 winnreAuth({
    //                     method: 'GET',
    //                     url: `/winnre/user/deals/${id}`
    //                 })
    //             )
    //         );
    //         apiCall.then((res) => {
    //             setBundleDealDetails(res);
    //         });
    //     } else {
    //         fetchBundleDeals(
    //             {
    //                 isEncryptedResponse: isAuthenticated ? true : false,
    //                 url: url,
    //                 method: 'get',
    //                 isFormData: true
    //             },
    //             (res) => {
    //                 setBundleDeals(res?.content);
    //                 dispatch(
    //                     dealAction.saveBundleDeals({
    //                         url,
    //                         deals: res?.content
    //                     })
    //                 );
    //                 const bundleIds = res?.content.map((offer) => offer.id);
    //                 let apiCall = Promise.all(
    //                     bundleIds?.map((id) =>
    //                         winnreAuth({
    //                             method: 'GET',
    //                             url: `/winnre/user/deals/${id}`
    //                         })
    //                     )
    //                 );
    //                 apiCall.then((res) => {
    //                     setBundleDealDetails(res);
    //                 });
    //             }
    //         );
    //     }
    // };

    const getBundleDealsWithSameTag = (id, dealId) => {
        const url = `/winnre/user/deals/filter-v2?&status=PUBLISHED&isAscending=false&sortBy=priority&categoryList=8&pageSize=10&tagList=${id}${
            isRewards ? '&rewardsPage=true' : ''
        }`;

        let cachedBundleDeals = state.deals.bundleDealCache[url] || null;
        if (cachedBundleDeals) {
            console.log('Using cached bundle deals:', cachedBundleDeals);
            const filteredBundleDeals = cachedBundleDeals.filter(
                (deal) => deal?.id === dealId
            );
            const otherBundleDeals = cachedBundleDeals.filter(
                (deal) => deal?.id !== dealId
            );
           
            // console.log("filteredCatchedBundleDeals" , filteredBundleDeals);
            setBundleDeals(filteredBundleDeals);
            setOtherBundleDeals(otherBundleDeals);
            const bundleIds = filteredBundleDeals.map((offer) => offer.id);
            let apiCall = Promise.all(
                bundleIds.map((id) =>
                    winnreAuth({
                        method: 'GET',
                        url: `/winnre/user/deals/${id}`
                    })
                )
            );
            apiCall.then((res) => {
                setBundleDealDetails(res);
            });
        } else {
            fetchBundleDeals(
                {
                    isEncryptedResponse: isAuthenticated ? true : false,
                    url: url,
                    method: 'get',
                    isFormData: true
                },
                (res) => {
                    // console.log("filteredDeals dealID" , dealId );
                    const filteredDeals = res?.content.filter(
                        (deal) => deal.id === dealId
                    );
                    const otherDeals = res.content.filter(
                        (deal) => deal.id !== dealId
                    );
                    setBundleDeals(filteredDeals);
                    setOtherBundleDeals(otherDeals);
                    dispatch(
                        dealAction.saveBundleDeals({
                            url,
                            deals: res?.content
                        })
                    );

                    const bundleIds = filteredDeals.map((offer) => offer.id);
                    let apiCall = Promise.all(
                        bundleIds.map((id) =>
                            winnreAuth({
                                method: 'GET',
                                url: `/winnre/user/deals/${id}`
                            })
                        )
                    );
                    apiCall.then((res) => {
                        setBundleDealDetails(res);
                    });
                }
            );
        }
    };

    const getSimilarOffersByCategory = (dealID, categoryID, rewardCategoryID , tagID) => {
        const oldCartData = localStorage.getItem('cartData');
        let cartData = {
            cartValues: [],
            totalPoints: 0,
            totalProduct: 0
        };
        if (oldCartData) {
            cartData = JSON.parse(oldCartData);
        }
        // const similarUrl = `/winnre/user/deals/filter-v2?status=PUBLISHED&isAscending=false&sortBy=priority&categoryList=${categoryID}&pageSize=10${
        //     categoryID == 8 ? `&tagList=${tagID}` : ''
        // }${isRewards ? '&rewardsPage=true' : ''}${
        //     isRewards && cartData.totalPoints > 0
        //         ? `&cartValue=${cartData.totalPoints}`
        //         : ''
        // }`;
        const similarUrl = `/winnre/user/deals/filter-v2?status=PUBLISHED&isAscending=false&sortBy=priority&${
            isRewards ? `rewardCategories=${rewardCategoryID}` : `categoryList=${categoryID}`
        }&pageSize=10${
            categoryID == 8 ? `&tagList=${tagID}` : ''
        }${isRewards ? '&rewardsPage=true' : ''}${
            isRewards && cartData.totalPoints > 0 ? `&cartValue=${cartData.totalPoints}` : ''
        }`;
        
        console.log('url', similarUrl);
        console.log('url', isRewards);
        let similarOffers = state.deals.similarOffers[similarUrl] || null;
        if (similarOffers) {
            // Use cached deals if available
            console.log('Using cached similar deals:', similarOffers);
            setSimilarOffers(
                similarOffers.filter((deal) => deal.id !== dealID)
            );
        } else {
            fetchSimilarDeals(
                {
                    isEncryptedResponse: isAuthenticated ? true : false,
                    url: similarUrl,
                    method: 'get',
                    isFormData: true
                },
                (res) => {
                    if (isRewards && totalRewardspoint > 0) {
                        const filteredRewards = res?.content?.filter(
                            (val) =>
                                val.points <
                                    totalRewardspoint - cartData.totalPoints &&
                                val.id !== dealID
                        );
                        setSimilarOffers(filteredRewards);
                    } else {
                        dispatch(
                            dealAction.saveSimilarDeals({
                                url: similarUrl,
                                deals: res?.content
                            })
                        );
                        setSimilarOffers(
                            res?.content.filter((deal) => deal.id !== dealID)
                        );
                    }
                }
            );
        }
    };

    const getOffersOfTheMonth = () => {
        const url =
            '/winnre/user/deals/filter-v2?status=PUBLISHED&isAscending=false&sortBy=priority&categoryList=1,2,3,5&pageSize=10&tagList=52';
        let monthOffers = state.deals.monthOffers[url] || null;
        if (monthOffers) {
            console.log('Using cached month deals:', monthOffers);
            setTopOffers(monthOffers ?? []);
        } else {
            winnreAuth({
                method: 'GET',
                url: url
            }).then((data) => {
                dispatch(
                    dealAction.saveOfferOfMonthDeals({
                        url: url,
                        deals: data?.content
                    })
                );
                setTopOffers(data?.content || []);
            });
        }
    };

    const getSameBrandOffers = (dealID, vendorID) => {
        const url = `/winnre/user/deals/filter-v2?status=PUBLISHED&isAscending=false&sortBy=priority&pageSize=10&vendorIds=${vendorID}`;
        let brandOffers = state.deals.brandOffers[url] || null;
        if (brandOffers) {
            console.log('Using cached same brand deals:', brandOffers);
            setSameBrandOffers(
                brandOffers.filter((deal) => deal.id !== dealID) || []
            );
        } else {
            winnreAuth({
                method: 'GET',
                url: url
            }).then((data) => {
                dispatch(
                    dealAction.saveSameBrandOffersDeals({
                        url: url,
                        deals: data?.content
                    })
                );
                setSameBrandOffers(
                    data?.content.filter((deal) => deal.id !== dealID) || []
                );
            });
        }
    };

    useEffect(() => {
        if (deal?.id > 0)
            getSimilarOffersByCategory(
                deal.id,
                deal?.category?.id,
                deal?.rewardCategory?.id, 
                deal?.tags[0]?.id
            );
    }, [isRewardRefreshing]);

    useEffect(() => {
        getDealDetails();
        if (isAuthenticated) {
            getOffersOfTheMonth();
        }
    }, [dealId, isAuthenticated]);

    return {
        deal,
        loadingDeal,
        similarOffers,
        topOffers,
        sameBrandOffers,
        bundleDeals,
        bundleDealDetails,
        faultyDeal,
        otherBundleDeals
    };
};

export default useData;
